export default "__VITE_ASSET__OeQuViN$__"